import { ApiResourceBaseClass as n } from "./baseApiCalls.js";
const a = "comments";
class c extends n {
  createComment = async (t) => {
    const { data: e } = await this.post(`${a}`, t);
    return e;
  };
  updateComment = async (t, e) => {
    const { data: s } = await this.put(`${a}/${e}`, t);
    return s;
  };
  deleteComment = async (t) => {
    const { data: e } = await this.delete(`${a}/${t}`);
    return e;
  };
}
export {
  c as Comments
};
